import h from 'react-hyperscript';

import { Link } from 'react-router';
import PropTypes from 'prop-types';
import R from 'ramda';
import classNames from 'classnames';

import styles from './button.css';

const Button = ({
    arrow = false,
    arrowPosition,
    children,
    classList = [],
    disabled = false,
    fill = false,
    href = '',
    mailto = false,
    size = 'medium',
    theme = 'one',
    ...props
}) => {
  const className = classNames(
    styles.button,
    R.prop(theme, styles),
    R.prop(size, styles),
    {
      [R.prop(`${arrowPosition}Arrow`, styles)]: arrow,
      [styles.fill]: fill,
      [styles.disabled]: disabled
    },
    ...classList
  );

  if (mailto) {
    return h('a', {
      className,
      href,
      ...props
    },
    children);
  }

  return h(Link,
    {
      className,
      to: disabled ? null : href,
      ...props
    },
    children
  );
};

Button.propTypes = {
    arrow: PropTypes.bool,
    arrowPosition: PropTypes.oneOf(['front', 'back']),
    href: PropTypes.string.isRequired,
    size: PropTypes.oneOf(['medium', 'big']),
    theme: PropTypes.oneOf(['one', 'two', 'white', 'disabled'])
};

export default Button;



/** WEBPACK FOOTER **
 ** ./src/Button/index.js
 **/